import { ReactElement } from "react";
import { PaymentsModalType } from "entities/shared/subscriptionModel";
import { subscriptionStore } from "entities/Subscription";
import { useAppSelector } from "shared/lib/redux";
import { useTranslation } from "shared/localization/localization";
import { Link } from "shared/ui/Button";
import { PRICING_PAGE_AIR_TRACKING_URL } from "shared/utils/url.utils";
import styles from "./PaymentsModalTopDescription.module.scss";

export const PaymentsModalTopDescription: RFC = () => {
  const { t } = useTranslation();

  const activePaymentModal = useAppSelector(subscriptionStore.selectors.activePaymentModal);

  const paymentsModalTopDescriptionMap: Record<PaymentsModalType, ReactElement | null> = {
    [PaymentsModalType.PAY]: (
      <p className={styles.payDescription}>
        {t(
          "To continue enjoying the full benefits of our tracking features and keep your important processes running smoothly, please explore our pricing plans and choose the one that best suits your needs"
        )}
        .
      </p>
    ),
    [PaymentsModalType.FREE]: (
      <div className={styles.freeDescription}>
        <p className={styles.freeDescriptionText}>
          {t("Your next 3 tracking searches will be available in 24 hours")}.{" "}
          {t(`Please note that the free plan allows for 3 searches per day, with a maximum of 10 per month`)}.{" "}
        </p>
        {t("Upgrade your account with one of our ")}{" "}
        {/* <Link target="_blank" href={PRICING_PAGE_AIR_TRACKING_URL} className={styles.descriptionLink}>
          {t("tariff plans")}
        </Link>{" "} */}
        {t(" to remove these restrictions and get the most out of our features")}.
      </div>
    ),
  };

  if (!activePaymentModal) return null;

  return paymentsModalTopDescriptionMap[activePaymentModal];
};
